export default [
  {
    path: 'atividades',
    component: require('./Read').default,
    meta: {
      middleware: 'auth',
      controller: 'AtividadeController'
    }
  },
  {
    path: 'familia/atividades/:id',
    component: require('./ReadFamilia').default,
    meta: {
      middleware: 'auth',
      controller: 'AtividadeController'
    }
  },
  {
    path: 'atividades/add',
    component: require('./Add').default,
    meta: {
      middleware: 'auth',
      controller: 'AtividadeController'
    }
  },
  {
    path: 'atividades/edit/:id',
    component: require('./Edit').default,
    name: 'edit-atividade',
    meta: {
      middleware: 'auth',
      controller: 'AtividadeController'
    }
  },
  {
    path: 'atividades/show/:id',
    component: require('./Show').default,
    meta: {
      middleware: 'auth',
      controller: 'AtividadeController'
    }
  },
  {
    path: 'atividades/ShowRelatorio/:id',
    component: require('./ShowRelatorio').default,
    meta: {
      middleware: 'auth',
      controller: 'AtividadeController'
    }
  },

  {
    path: 'relatorios/atividades',
    component: require('./reports/Reports').default,
    redirect: 'relatorios/atividades/home',
    meta: { middleware: 'auth', controller: 'RelatorioAtividadeController' },
    children: [{
      path: 'home',
      name: "relatorios_home_atividades",
      component: require('./reports/includes/Home').default,
      meta: { middleware: 'auth', controller: 'RelatorioAtividadeController' },
    },
    {
      path: 'inscritos',
      name: "relatorios_home_atividades_inscritos",
      component: require('./reports/includes/Inscritos').default,
      meta: { middleware: 'auth', controller: 'RelatorioAtividadeController' },
    }, {
      path: 'graficos',
      name: 'graficos_atividades',
      component: require('./reports/includes/Graficos').default,
      meta: { middleware: 'auth', controller: 'RelatorioAtividadeController' },
    },
    {
      path: 'participacoes/:id',
      name: "relatorios_home_atividades_participacoes",
      component: require('./reports/includes/ParticipacoesAtividades').default,
      meta: { middleware: 'auth', controller: 'RelatorioAtividadeController' },
    },
    ]
  }

]
